import { render, staticRenderFns } from "./TabletSaveUI.vue?vue&type=template&id=191791b0&scoped=true&"
import script from "./TabletSaveUI.vue?vue&type=script&lang=js&"
export * from "./TabletSaveUI.vue?vue&type=script&lang=js&"
import style0 from "./TabletSaveUI.vue?vue&type=style&index=0&id=191791b0&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191791b0",
  null
  
)

export default component.exports